<template>
    <BaseLayout>
        <div class="m-auto">
            <div class="container">
                <h1 class="text-primary">{{ title }}</h1>
                <div>{{ description }}</div>
            </div>
        </div>
    </BaseLayout>
</template>

<script setup>
import { computed } from 'vue';
import BaseLayout from '../Layouts/BaseLayout.vue';

const props = defineProps({ status: Number, maintenanceMessage: String })

const title = computed(() => {
    return {
        503: '503: Service Unavailable',
        500: '500: Server Error',
        404: '404: Page Not Found',
        403: '403: Forbidden',
    }[props.status]
})

const description = computed(() => {
    return {
        503: props.maintenanceMessage,
        500: 'Whoops, something went wrong on our servers.',
        404: 'Sorry, the page you are looking for could not be found.',
        403: 'Sorry, you are forbidden from accessing this page.',
    }[props.status]
})
</script>
